import {
  Box,
  BoxProps,
  Button,
  HStack,
  useBreakpointValue,
  useConst,
} from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

import { TypeUtils } from '../../../../../../framework/utils/UtilityTypes';
import StyledButton from '../../../../../components/StyledButton';

/**
 * ボタンエリアプロパティ
 */
export type OperationButtonAreaProps = {
  /**
   * 手配済フラグ
   */
  isApplied: boolean;
  /**
   * 外注フラグ
   */
  isOutsourcer: boolean;
  /**
   * 職人アサインボタンクリックイベント
   */
  onClickWorkerAssignment?: Runnable;
  /**
   * 手配ボタンクリックイベント
   */
  onClickAssignment?: Runnable;
  /**
   * 作業報告書ボタンクリックイベント
   */
  onClickWorkReport?: Runnable;
  /**
   * 現場経費ボタンクリックイベント
   */
  onClickMatterExpense?: Runnable;
  /**
   * 就業報告ボタンクリックイベント
   */
  onClickWorkContent?: Runnable;
};

type ButtonAreaProps = PropsWithChildren<{
  hidden?: boolean;
  isDisabled?: boolean;
  /**
   * ボタンエリア名
   */
  name?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}>;

/**
 * ボタンエリアフック
 * @returns
 */
export const useOperationButtonArea = () => {
  const areaWidth = useConst(40 * 5 + 6 * 4);
  const width = useBreakpointValue({ base: 'full', md: `${areaWidth}px` });
  const buttonWidth = useBreakpointValue({ base: '48px', md: '40px' });

  const ButtonArea: React.FunctionComponent<ButtonAreaProps> = ({
    children,
    hidden,
    isDisabled,
    name,
    onClick,
  }) => (
    <Box key={name} marginInlineStart="0 !important" width={buttonWidth}>
      <StyledButton
        hidden={hidden}
        isDisabled={isDisabled}
        onClick={onClick}
        size="xs"
        width={buttonWidth}
      >
        {children}
      </StyledButton>
    </Box>
  );

  /**
   * ボタンエリア
   * @param props - プロパティ
   * @returns JSX要素
   */
  const OperationButtonArea: React.FunctionComponent<
    BoxProps & OperationButtonAreaProps
  > = ({
    isApplied,
    isOutsourcer,
    onClickWorkContent,
    onClickMatterExpense,
    onClickWorkerAssignment,
    onClickAssignment,
    onClickWorkReport,
    ...props
  }) => (
    <HStack
      className="daily-report-popovers"
      justifyContent="space-around"
      width={width}
      {...props}
    >
      <ButtonArea
        name="手配"
        hidden={TypeUtils.isNil(onClickAssignment)}
        onClick={onClickAssignment}
      >
        {isOutsourcer ? '受注' : '手配'}
      </ButtonArea>
      <ButtonArea
        name="アサイン"
        hidden={TypeUtils.isNil(onClickWorkerAssignment)}
        onClick={onClickWorkerAssignment}
      >
        職ア
      </ButtonArea>
      <ButtonArea
        name="就業報告"
        hidden={TypeUtils.isNil(onClickWorkContent)}
        onClick={onClickWorkContent}
      >
        就業
      </ButtonArea>
      <ButtonArea
        name="作業報告書"
        hidden={TypeUtils.isNil(onClickWorkReport)}
        onClick={onClickWorkReport}
      >
        作業
      </ButtonArea>
      <ButtonArea
        hidden={TypeUtils.isNil(onClickMatterExpense)}
        name="現場経費"
        onClick={onClickMatterExpense}
      >
        経費
      </ButtonArea>
    </HStack>
  );

  return { OperationButtonArea, areaWidth };
};
